import type { Action } from 'redux';

export interface SettingsState {
  isDebug: boolean;
  isALC: boolean;
}

interface ToggleDebugAction extends Action {
  type: 'TOGGLE_DEBUG';
}

interface SetIsALCAction extends Action {
  type: 'SET_IS_ALC';
}

interface SetIsNotALCAction extends Action {
  type: 'SET_IS_NOT_ALC';
}

interface ToggleIsALCAction extends Action {
  type: 'TOGGLE_IS_ALC';
}

type SettingsAction = ToggleDebugAction | SetIsALCAction | SetIsNotALCAction | ToggleIsALCAction;

const defaultState: SettingsState = {
  isDebug: false,
  isALC: false,
};

function reducer(state: SettingsState = defaultState, action: SettingsAction): SettingsState {
  switch (action.type) {
    case 'TOGGLE_DEBUG': {
      return {
        ...state,
        isDebug: !state.isDebug,
      };
    }
    case 'SET_IS_ALC': {
      return {
        ...state,
        isALC: true,
      };
    }
    case 'SET_IS_NOT_ALC': {
      return {
        ...state,
        isALC: false,
      };
    }
    case 'TOGGLE_IS_ALC': {
      return {
        ...state,
        isALC: !state.isALC,
      };
    }
    default:
      return state;
  }
}

export default reducer;
